var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.77051,
    y: 3.16797,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3101_57016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1041 26.5012L23.7707 23.1679M23.7707 23.1679L20.4374 26.5012M23.7707 23.1679V30.6679M30.7624 28.4929C31.5752 28.0498 32.2172 27.3486 32.5873 26.5001C32.9573 25.6515 33.0342 24.7039 32.8059 23.8068C32.5776 22.9097 32.057 22.1141 31.3263 21.5457C30.5956 20.9774 29.6964 20.6685 28.7707 20.6679H27.7207C27.4685 19.6922 26.9984 18.7865 26.3457 18.0187C25.693 17.2509 24.8748 16.6411 23.9525 16.235C23.0302 15.829 22.0278 15.6373 21.0208 15.6744C20.0138 15.7115 19.0283 15.9765 18.1384 16.4493C17.2485 16.9221 16.4773 17.5905 15.8829 18.4042C15.2885 19.2179 14.8863 20.1558 14.7065 21.1474C14.5268 22.1389 14.5741 23.1583 14.8451 24.1289C15.116 25.0995 15.6034 25.9961 16.2707 26.7512",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.77051,
    y: 3.16797,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3101_57016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.7705 13.168)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.54dab43d1a7dce271106e2d8291b1c66.svg";
export { ForwardRef as ReactComponent };